export default "__VITE_ASSET__oThapR3g__"